// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_02712f2b3b--tooltip--iKIv0","arrow_tooltip":"_02712f2b3b--arrow_tooltip--FnHui","arrow":"_02712f2b3b--arrow--M3H38"};